import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@mantine/core";
import { CenteredCard } from "@/components/CenteredCard";
import { authSearchSchema } from "@/features/auth/redirect";
function AuthError() {
  const { next } = Route.useSearch();
  return (
    <CenteredCard
      title="Sign-in was not completed"
      description="The provider cancelled or could not complete sign-in. Your invitation or authorization request has been kept in this tab."
    >
      <Button component="a" href={`/auth/sign-in?${new URLSearchParams(next ? { next } : {})}`}>
        Try sign-in again
      </Button>
    </CenteredCard>
  );
}
export const Route = createFileRoute("/auth/error")({
  validateSearch: authSearchSchema,
  component: AuthError,
});
